import { Button, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { CaretDown } from '@phosphor-icons/react'

const languages = {
  en: 'English',
  es: 'Español',
  pl: 'Polski',
  zh: '中文'
}

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  return (
    <Menu closeOnBlur={true}>
      <MenuButton
        as={Button}
        rightIcon={<CaretDown />}
        variant="ghost"
        size="sm"
      >
        {languages[i18n.language as keyof typeof languages] || languages.en}
      </MenuButton>
      <MenuList>
        {Object.entries(languages).map(([code, name]) => (
          <MenuItem
            key={code}
            onClick={() => i18n.changeLanguage(code)}
            fontWeight={i18n.language === code ? 'bold' : 'normal'}
          >
            {name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}

export default LanguageSwitcher 